import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import FeedbackPage from "../pages/Feedback";
import Policy from "../pages/Policy";
import FAQPage from "../pages/FAQs";
import ViewAllOrders from "../pages/view-all-orders";
import CollectCash from "../pages/collect-cash";
import ReportPage from "../pages/Report";
import RequestCallPage from "../pages/request-call-back";
import AddBarCodePage from "../pages/BarCode";
import PlaceManualOrder from "../pages/place-manual-order";
import PendingSettlement from "../pages/pending-settlement";
import AddInstruction from "../pages/add-instruction";
import ComplaintPage from "../pages/Complaints";
import ManageComplaintPage from "../pages/manage-complaint";
import AddCoupon from "../pages/add-coupon";
import AddRole from "../pages/add-role";
import AddMember from "../pages/add-member";
import AddWalletBalance from "../pages/add-wallet-balance";
import TrackOrder from "../pages/track-order";
import ManageMemberPage from "../pages/manage-member";
import Analytics from "../pages/Analytics";
import SlotManagmentPage from "../pages/slot-managment";


const PrivateRoutes = ({ auth }) => {
  return (
    auth && (
      <Routes>
        <Route path="/add-policy" element={<Policy />} />
        <Route path="/add-instruction" element={<AddInstruction />} />
        <Route path="/add-member" element={<AddRole />} />
        <Route path="/generate-login" element={<AddMember />} />
        <Route path="/view-all-order" element={<ViewAllOrders />} />
        <Route path="/track-order" element={<TrackOrder />} />
        <Route path="/reports" element={<ReportPage />} />
        <Route path="/question" element={<FAQPage />} />
        <Route path="/feedback" element={<FeedbackPage/>} />
        <Route path="/manage-member" element={<ManageMemberPage />} />
        <Route path="/complaints" element={<ComplaintPage />} />
        <Route path="/manage-complaint" element={<ManageComplaintPage />} />
        <Route path="/add-coupon" element={<AddCoupon />} />
        <Route path="/add-wallet-balance" element={<AddWalletBalance />} />
        <Route path="/manage-member" element={<ManageMemberPage />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/tickets" element={<RequestCallPage />} />
        <Route path="/add-barcodes" element={<AddBarCodePage />} />
        <Route path="/place-manual-order" element={<PlaceManualOrder />} />
        <Route path="/pending-settlement" element={<PendingSettlement />} />
        <Route path="/collect-cash" element={<CollectCash />} />
        <Route path="/slot-managment" element={<SlotManagmentPage />} />
        <Route path="*" element={<Navigate to="/analytics" />} />
      </Routes>
    )
  );
};

export default PrivateRoutes;
